import { render, staticRenderFns } from "./divisionrule.vue?vue&type=template&id=e9e16200&scoped=true"
import script from "./divisionrule.vue?vue&type=script&lang=js"
export * from "./divisionrule.vue?vue&type=script&lang=js"
import style0 from "./divisionrule.vue?vue&type=style&index=0&id=e9e16200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e16200",
  null
  
)

export default component.exports